import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation } from "react-router-dom";
import { getLanguage, getLanguageName, setLanguage } from "../helpers/storageHelper";
import AnnouncementBar from "../components/landing/AnnouncementBar";

function Header() {

    const { i18n, t } = useTranslation();
    const location = useLocation();
    const supportPaths = ["/donationDetails", "/sponsorshipPlan", "/lovelyMealPlan", "/charitySales", "/donate"];
    const infoPaths = ["/aboutUs", "/ourOrganization", "/career", "/faq"];

    function handleChangeLanguage(event) {
        if(getLanguage() == 1) {
            i18n.changeLanguage("2");
            setLanguage(2);
        }
        else if(getLanguage() == 2) {
            i18n.changeLanguage("1");
            setLanguage(1);
        }
        else {
            i18n.changeLanguage("1");
            setLanguage(1);
        }
    }

    const navLinkClass = ({ isActive }) => "landing-nav-link nav-link" + (isActive ? " active" : "");
    const isSupportActive = supportPaths.includes(location.pathname);
    const isInfoActive = infoPaths.includes(location.pathname);

    useEffect(() => {
        const navbarCollapse = document.getElementById("navbarNav");
        const dropdownMenus = document.querySelectorAll(".landing-dropdown-menu.show");
        const dropdownToggles = document.querySelectorAll(".landing-dropdown-toggle[aria-expanded='true']");

        navbarCollapse?.classList.remove("show");
        dropdownMenus.forEach((menu) => menu.classList.remove("show"));
        dropdownToggles.forEach((toggle) => toggle.setAttribute("aria-expanded", "false"));
    }, [location.pathname]);

    return (
        <>
        {location.pathname === "/" && <AnnouncementBar />}
        <nav className="navbar navbar-expand-lg sticky-top landing-nav">
            <div className="container">
                <Link className="navbar-brand landing-brand" to="/">
                    <img src="assets/img/80_sdlogo.png" alt="logo" className="logo-icon" />
                    <span className="landing-brand-text">
                        <span className="landing-brand-cn">{t("shande")}</span>
                        <span className="landing-brand-en">SHANDECHILDREN'S HOME</span>
                    </span>
                </Link>
                <button data-bs-toggle="collapse" data-bs-target="#navbarNav" className="landing-toggler navbar-toggler" type="button">
                    <span className="visually-hidden">Toggle navigation</span>
                    <span className="landing-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-lg-center">
                        <li className="nav-item"><NavLink className={navLinkClass} to="/">{t("home")}</NavLink></li>
                        <li className="nav-item dropdown landing-nav-dropdown">
                            <button
                                type="button"
                                className={"landing-nav-link nav-link dropdown-toggle landing-dropdown-toggle" + (isInfoActive ? " active" : "")}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {t("shandeInfo")}
                            </button>
                            <ul className="dropdown-menu landing-dropdown-menu">
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/aboutUs">{t("aboutUs")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/ourOrganization">{t("ourOrganization")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/career">{t("career")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/faq">{t("faq")}</NavLink></li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown landing-nav-dropdown">
                            <button
                                type="button"
                                className={"landing-nav-link nav-link dropdown-toggle landing-dropdown-toggle" + (isSupportActive ? " active" : "")}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {t("supportUs")}
                            </button>
                            <ul className="dropdown-menu landing-dropdown-menu">
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/donationDetails">{t("donationDetails")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/sponsorshipPlan">{t("sponsorshipPlan")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/lovelyMealPlan">{t("lovelyMealPlan")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/charitySales">{t("charitySales")}</NavLink></li>
                                <li><NavLink className={({ isActive }) => "dropdown-item landing-dropdown-item" + (isActive ? " active" : "")} to="/donate">{t("donateNow")}</NavLink></li>
                            </ul>
                        </li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/news">{t("news")}</NavLink></li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/events">{t("events")}</NavLink></li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/contactUs">{t("contactUs")}</NavLink></li>
                        <li className="nav-item">
                            <button type="button" onClick={handleChangeLanguage} className="landing-lang">{getLanguageName()}</button>
                        </li>
                        <li className="nav-item">
                            <Link className="landing-nav-donate" to="/donate">{t("donateNow")}</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        </>
    )
}
export default Header;